import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { RecommendationPictureComponent } from "../recommendation-picture/recommendation-picture.component";
import { RecommendationDetailComponent } from "../recommendation-detail/recommendation-detail.component";

@Component({
  selector: 'dpi-recommendation-hub',
  imports: [MatTabsModule, MatBadgeModule, RecommendationPictureComponent, RecommendationDetailComponent],
  templateUrl: './recommendation-hub.component.html',
  styleUrl: './recommendation-hub.component.scss'
})
export class RecommendationHubComponent {
  pictureNum: number;

  constructor() {
    this.pictureNum = 0;
  }

  setPictureNum(count: number) {
    this.pictureNum = count;
  }
  
}
